import styled from 'styled-components';
import theme from '../../theme';

export const ModalContainer = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
  overflow: hidden;
`;

export const ModalContent = styled.div`
  background-color: ${theme.colors.cardB1};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 20px;
  max-height: 80vh;
  min-height: 60vh;
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ModalTitle = styled.h2`
  color: white;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0;
  letter-spacing: 0.5px;
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const CloseButton = styled.button`
  padding: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const CloseButtonText = styled.span`
  color: white;
  font-size: 24px;
  font-weight: bold;
`;

export const ScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  width: 100%;
  max-height: 50vh;
  padding-right: 4px;
  margin-right: -4px;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 8px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.notifications};
    border-radius: 8px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.notifications}dd;
  }
`;

export const ActivityItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${theme.colors.primary};
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);
  
  &:hover {
    background-color: ${theme.colors.primary2};
    border-color: rgba(230, 255, 0, 0.2);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const ActivityCheckbox = styled.div<{ selected?: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: 2px solid ${({ selected }) => (selected ? theme.colors.notifications : 'rgba(255, 255, 255, 0.3)')};
  background-color: ${({ selected }) => (selected ? theme.colors.notifications : 'transparent')};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  flex-shrink: 0;
  transition: all 0.2s ease;
  
  ${({ selected }) => selected && `
    box-shadow: 0 0 12px ${theme.colors.notifications}40;
  `}
`;

export const ActivityCheckboxIcon = styled.span`
  color: ${theme.colors.primary};
  font-size: 16px;
  font-weight: bold;
`;

export const ActivityInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ActivityLeftInfo = styled.div`
  flex: 1;
`;

export const ActivityTitle = styled.p`
  color: white;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 5px 0;
`;

export const ActivityDistance = styled.p`
  color: ${theme.colors.text};
  font-size: 14px;
  margin: 0;
`;

export const ActivityDate = styled.p`
  color: ${theme.colors.text};
  font-size: 13px;
  font-weight: 500;
  margin: 0;
`;

export const DistanceInfo = styled.div`
  background: linear-gradient(135deg, ${theme.colors.primary2} 0%, ${theme.colors.primary3} 100%);
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(230, 255, 0, 0.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const DistanceText = styled.p`
  color: white;
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  
  strong {
    color: ${theme.colors.notifications};
    font-weight: 700;
  }
`;

export const ConfirmButton = styled.button`
  background: linear-gradient(135deg, ${theme.colors.notifications} 0%, ${theme.colors.graph} 100%);
  padding: 18px 32px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  margin: 20px auto 4px;
  width: 100%;
  max-width: 400px;
  display: block;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(230, 255, 0, 0.3);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(230, 255, 0, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const ConfirmButtonText = styled.span`
  color: ${theme.colors.primary};
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
`;

export const EmptyText = styled.p`
  color: ${theme.colors.text};
  font-size: 16px;
  text-align: center;
  margin-top: 20px;
  padding: 20px;
`;

export const modalStyle = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    padding: '20px',
    overflowY: 'auto' as const,
    overflowX: 'hidden' as const,
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  content: {
    position: 'static' as const,
    width: '100%',
    maxWidth: '675px',
    height: 'fit-content',
    maxHeight: '90vh',
    border: 'none',
    borderRadius: '20px',
    inset: 'auto',
    background: theme.colors.cardB1,
    padding: '24px',
    margin: 'auto',
    overflowY: 'auto' as const,
    overflowX: 'hidden' as const,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
  },
};
